import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/query-keys";
import type { IUser } from "./getMe";

/**
 * 특정 사용자의 정보를 가져옵니다.
 */
export const apiGetUser = async (id: string) => {
  const response = await apiGet<IUser>(`/users/${id}`);
  return response;
};

/**
 * 특정 사용자의 정보를 React Query를 통해 가져오는 훅
 */
export const useQueryGetUser = (id: string, options = {}) => {
  return useQuery({
    queryKey: QueryKeys.user.detail(id),
    queryFn: async () => {
      const response = await apiGetUser(id);
      return response.data;
    },
    ...options,
  });
};

export default useQueryGetUser;
